import { useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const prevPathnameRef = useRef(null);
  
    useEffect(() => {
      const prevPathname = prevPathnameRef.current;

      if (prevPathname !== null && prevPathname !== pathname && (!prevPathname.includes("worldlist") || !pathname.includes("worldlist"))) {
        window.scrollTo(0, 0); // Scroll to top on route change
      }

      prevPathnameRef.current = pathname;
    }, [pathname]);
  
    return null;
  };
  
  export default ScrollToTop;
  